@if (task()) {
  <div class="task-wrapper">
    <div class="container" [class.clickable]="true" (click)="onTask(task())">
      <div class="f-c left-container">
        <oph-icon
          class="task-icon"
          [name]="'color-icons/' + task().icon"
          [size]="32"
          imageErrorName="color-icons/clock-time-watch"
        ></oph-icon>
        <span class="label">{{ task().label || '' }}</span>
      </div>

      <div class="right-container f-c">
        @if (task()?.batchId) {
          <oph-icon name="repeat-green" [size]="18"></oph-icon>
        }
        @if (task() | isTaskExpired) {
          <div class="status expired">Expired</div>
        } @else {
          <div class="subtask-count">{{ task().subtasks.length || 0 }}</div>
        }
        <div class="status" [style.background]="(task().status | taskStatusInfo).color">
          {{ (task().status | taskStatusInfo).text }}
        </div>
        <div class="users-container">
          <oph-avatar-multi
            [userIds]="task().users"
            [tooltipPosition]="'above'"
            [toolTipDisabled]="false"
            [avatarSize]="28"
            [maxVisible]="4"
          ></oph-avatar-multi>
          @if (task().users.length === 1) {
            <span class="user-name"
              >{{ usersMap()[task().users[0]]?.firstName }}
              {{ usersMap()[task().users[0]]?.lastName | slice: 0 : 1 }}</span
            >
          }
        </div>
        <div class="repeating-chevron-container">
          @if (task().batchId) {
            @if (repeatingTaskHistory()?.loading) {
              <div class="oph-orange-spinner">
                <mat-spinner diameter="19"></mat-spinner>
              </div>
            } @else {
              <mat-icon
                svgIcon="chevron-down"
                size="18"
                class="repeating-chevron"
                [class.expanded]="expandedState()"
              ></mat-icon>
            }
          }
        </div>
      </div>
    </div>

    <div class="expanded-container" [class.expanded]="expandedState()" [class.no-animation]="firstLoad()">
      <div class="expanded-content">
        <span class="repeating-task-history-label">Repeating task history</span>
        @for (task of repeatingTaskHistory()?.tasks; track task) {
          <button (click)="onTask(task, true)">
            <div class="name-container">
              <oph-checkbox
                [checked]="task.status === taskStatuses.Completed"
                (valueChange)="onCheckbox($event, task)"
                (click)="$event.stopPropagation()"
                [width]="25"
                color="green"
              ></oph-checkbox>
              <span class="date-text">{{ task.startDateTime | convertUtcToTimezone: 'dddd, MMM D YYYY' }}</span>
            </div>

            <div class="right-container expanded-right-container">
              @if (task | isTaskExpired) {
                <div class="status expired">Expired</div>
              }
              <div class="status" [style.background]="(task.status | taskStatusInfo).color">
                {{ (task.status | taskStatusInfo).text }}
              </div>

              <div class="users-container">
                <oph-avatar-multi
                  [userIds]="activityUsers()"
                  [tooltipPosition]="'above'"
                  [toolTipDisabled]="false"
                  [avatarSize]="28"
                  [maxVisible]="4"
                ></oph-avatar-multi>
                @if (activityUsers().length === 1) {
                  <span class="user-name"
                    >{{ usersMap()[activityUsers()[0]]?.firstName }}
                    {{ usersMap()[activityUsers()[0]]?.lastName | slice: 0 : 1 }}</span
                  >
                }
              </div>
            </div>
          </button>
        }

        @if (repeatingTaskHistory()?.tasks?.length && repeatingTaskHistory()?.pagination?.totalPages > 1) {
          <oph-paginator
            [page]="repeatingTaskHistory().pagination.page"
            [totalPages]="repeatingTaskHistory().pagination.totalPages"
            [preventRouting]="true"
            (pageChange)="onPageChange($event)"
          ></oph-paginator>
        }
      </div>
    </div>
  </div>
}
